// import axios from 'axios';
// import store from '../../redux/store/store';
// import { setDisable } from '../../redux/slices/privateRouteAuthorizations';
// import config from '../../config'
// import { AuthenticationService } from '../../services/authenticationService';
// import logger from '../../utils/logger';

// const baseURL = config.REACT_APP_BASE_URL

// // logger.info('baseURL: ', baseURL)
// // logger.info('config: ',config)


// let isRefreshing = false;
// let subscribers = [];
// var timer;

// // Agrega el token a las solicitudes
// const apiClient = axios.create({
//   baseURL
// });

// //! UTILIZAR TOKEN TYPE DEL LOCALSTORAGE

// // Función para agregar el token a las cabeceras
// apiClient.interceptors.request.use((config) => {
//   //Solo enviamos el access token si no es el login
//   if (config.url.indexOf("Authentication/Login") < 0) {
//     const localAccessToken = localStorage.getItem('access-token')
//     //console.log('localAccessToken es desde la request: ', localAccessToken)

//     const queryString = config.params
//       ? `?${new URLSearchParams(config.params).toString()}`
//       : '';

//     const fullUrl = `${config.baseURL}${config.url}${queryString}`;
//     console.log('👉 URL final:', fullUrl);


//     if (localAccessToken) {
//       setupTokenRefresh();
//       config.headers['Authorization'] = `Bearer ${localAccessToken}`;
//     }
//   }


//   //console.log('config: ', config)
//   return config;
// }, (error) => {
//   // 👇 Si ocurre un error en Axios al preparar la solicitud
//   return Promise.reject({
//     type: "AXIOS_CONFIG_ERROR",
//     message: "Falló la configuración de Axios",
//     details: error,
//   });
// });

// //?Alternativa para el temporizador

// let isTimerActive = false //👉 Variable global para controlar el temporizador

// export const setupTokenRefresh = async () => {

//   logger.info('seteando el temporizador...')
//   const localTokenExpiry = localStorage.getItem('expire-in');
//   const localRefreshToken = localStorage.getItem('refresh-token')

//   if (!localTokenExpiry || !localRefreshToken) {
//     logger.info('No hay información de token disponible.')
//     return
//   }

//   const currentTime = Date.now();
//   const timeUntilRefresh = parseFloat(localTokenExpiry) - currentTime / 1000

//   //!👉 Evita configurar un nuevo temporizador si ya hay uno activo
//   if (isTimerActive) {
//     logger.info('Ya hay un temporizador activo.')
//     return
//   }

//   if (timeUntilRefresh <= 10) {
//     refreshAccessToken()
//   } else {
//     //console.log(
//     //   `Programando renovación del accessToken en ${parseFloat(
//     //     timeUntilRefresh
//     //   ).toFixed(2)} segundos`
//     // );
//     isTimerActive = true //👉 Indica que hay un temporizador activo

//     if (timer) {
//       clearTimeout(timer);

//     }

//     logger.info('preparando un nuevo temporizador, tiempo: ', (timeUntilRefresh - 10) * 1000)
//     timer = setTimeout(() => {

//       refreshAccessToken()
//       isTimerActive = false //👉 Restablece la variable al completar

//     }, (timeUntilRefresh - 10) * 1000)

//   }
// }


// //?                                   

// const refreshAccessToken = async () => {
//   try {
//     logger.info("Trying to refresh");

//     if (isRefreshing) {
//       return;
//     }
//     //console.log("Refreshing token");

//     isRefreshing = true;
//     const response = await AuthenticationService.refreshToken();

//     isRefreshing = false;

//     if (response) {

//       //console.log('respuesta del refreshToken', response)
//       //👉 Asumiendo que recibes un nuevo token y tiempo de expiración con esta estructura
//       const { accessToken, refreshToken, expiresIn } = response

//       //👉 Se Calcula la nueva hora de expiración
//       const newExpiryTime = Date.now() / 1000 + expiresIn

//       //👉Se Guarda el nuevo token y tiempo de expiración en localStorage
//       localStorage.setItem('access-token', accessToken)
//       localStorage.setItem('expire-in', newExpiryTime)
//       localStorage.setItem('refresh-token', refreshToken)

//       logger.info('Token renovado con éxito:')

//       //👉 Si la peticion a refreshTokenEndpoint no arroja un error Programa el siguiente intento de renovación
//       // setupTokenRefresh()

//       const currentTime = Date.now();
//       const timeUntilRefresh = parseFloat(newExpiryTime) - currentTime / 1000

//       isTimerActive = true //👉 Indica que hay un temporizador activo

//       if (timer) {
//         clearTimeout(timer);
//       }

//       timer = setTimeout(() => {
//         refreshAccessToken()
//         isTimerActive = false //👉 Restablece la variable al completar
//       }, (timeUntilRefresh - 10) * 1000)
//     }

//   } catch (error) {
//     logger.info('error arrojado desde refreshAccessToken():', error)
//     // localStorage.setItem("authStatus", 'unauthorized')
//     // localStorage.clear();
//     // window.location.href = '/login'
//     // throw error

//   }
// }



// //👉 Interceptor de Respuesta (FILTRADO DE RESPUESTA)
// apiClient.interceptors.response.use(
//   (response) => {

//     // logger.info('interceptors.response: ',response.config.url.indexOf("Authentication/Login"))
//     if (response.config.url.indexOf("Authentication/Login") !== -1) {
//       logger.debug('respuesta del login:', response)

//     }

//     return response
//   },
//   (error) => {
//     if (error.response) {

//       const { status, data } = error.response
//       let message

//       switch (status) {
//         case 400:
//           message = data.message || 'Solicitud incorrecta.'
//           break;
//         case 401:
//           message = data.message || 'No autorizado. Por favor, inicie sesión.'
//           logger.info('api.data.message: ', data.message)
//           localStorage.clear();
//           store.dispatch(setDisable())
//           // window.location.href = '/login';
//           break;

//         case 403:
//           message = data.message || 'No tienes permiso para realizar esta acción.'
//           break;

//         case 409:
//           //console.log('axiosConfig recibiendo el error...', data.message)
//           message = data.message || 'Conflicto en los datos enviados.'
//           break;
//         default:
//           message = data.message || 'Ocurrió un error desconocido.'
//       }

//       //👉 se crea un nuevo tipo de error
//       return Promise.reject({
//         status,
//         message,
//       })
//     }
//     //👉 Se retorna el nuevo error para que lo capture registerService en el catch (postData)
//     return Promise.reject(error)
//   }
// )

// export default apiClient;






// import axios from 'axios';
// import store from '../../redux/store/store';
// import { setDisable } from '../../redux/slices/privateRouteAuthorizations';
// import config from '../../config'
// import { AuthenticationService } from '../../services/authenticationService';
// import logger from '../../utils/logger';

// const baseURL = config.REACT_APP_BASE_URL;
// const apiClient = axios.create({ baseURL });

// // --- Comunicación entre pestañas ---
// const authChannel = new BroadcastChannel('auth_sync_channel');

// let isRefreshing = false;
// let isTimerActive = false;
// let timer;

// // Escuchar mensajes de otras pestañas
// authChannel.onmessage = (event) => {
//   const { type } = event.data;
//   if (type === 'REFRESH_STARTED') {
//     isRefreshing = true;
//     logger.info('Otra pestaña inició la renovación.');
//   } else if (type === 'REFRESH_COMPLETED') {
//     isRefreshing = false;
//     isTimerActive = false;
//     setupTokenRefresh(); // Re-programar con los nuevos datos del localStorage
//     logger.info('Otra pestaña terminó la renovación, timer reiniciado.');
//   }
// };

// export const setupTokenRefresh = async () => {
//   const localTokenExpiry = localStorage.getItem('expire-in');
//   const localRefreshToken = localStorage.getItem('refresh-token');

//   if (!localTokenExpiry || !localRefreshToken) return;

//   const currentTime = Date.now();
//   const timeUntilRefresh = parseFloat(localTokenExpiry) - currentTime / 1000;

//   if (isTimerActive) return;

//   if (timeUntilRefresh <= 10) {
//     refreshAccessToken();
//   } else {
//     isTimerActive = true;
//     if (timer) clearTimeout(timer);

//     logger.info(`Temporizador programado para dentro de ${timeUntilRefresh - 10}s`);
//     timer = setTimeout(() => {
//       refreshAccessToken();
//       isTimerActive = false;
//     }, (timeUntilRefresh - 10) * 1000);
//   }
// };

// const refreshAccessToken = async () => {
//   if (isRefreshing) return;

//   try {
//     isRefreshing = true;
//     // Avisar a otras pestañas que NO intenten refrescar
//     authChannel.postMessage({ type: 'REFRESH_STARTED' });

//     logger.info("Iniciando renovación de token...");
//     const response = await AuthenticationService.refreshToken();

//     if (response) {
//       const { accessToken, refreshToken, expiresIn } = response;
//       const newExpiryTime = Date.now() / 1000 + expiresIn;

//       localStorage.setItem('access-token', accessToken);
//       localStorage.setItem('expire-in', newExpiryTime);
//       localStorage.setItem('refresh-token', refreshToken);

//       logger.info('Token renovado con éxito.');

//       isRefreshing = false;
//       // Avisar que terminamos para que todas actualicen sus timers
//       authChannel.postMessage({ type: 'REFRESH_COMPLETED' });

//       // Reiniciar timer local
//       isTimerActive = false;
//       setupTokenRefresh();
//     }
//   } catch (error) {
//     isRefreshing = false;
//     logger.error('Error en refreshAccessToken:', error);
//     // Opcional: authChannel.postMessage({ type: 'REFRESH_ERROR' });
//   }
// };

// // --- Interceptores ---
// apiClient.interceptors.request.use((config) => {
//   if (config.url.indexOf("Authentication/Login") < 0) {
//     const localAccessToken = localStorage.getItem('access-token');
//     if (localAccessToken) {
//       setupTokenRefresh();
//       config.headers['Authorization'] = `Bearer ${localAccessToken}`;
//     }
//   }
//   return config;
// }, (error) => Promise.reject(error));

// apiClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       localStorage.clear();
//       store.dispatch(setDisable());
//     }
//     return Promise.reject(error);
//   }
// );

// export default apiClient;




//? PRUEBA 3

import axios from 'axios';
import store from '../../redux/store/store';
import { setDisable } from '../../redux/slices/privateRouteAuthorizations';
import config from '../../config';
import { requestLogout } from '../auth/logAuth';
import logger from '../../utils/logger';

const apiClient = axios.create({
  baseURL: config.REACT_APP_BASE_URL,
});

// -------------------------------
// Request
// -------------------------------
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('access-token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }


    const queryString = config.params
      ? `?${new URLSearchParams(config.params).toString()}`
      : '';

    const fullUrl = `${config.baseURL}${config.url}${queryString}`;
    console.log('👉 URL final:', fullUrl);


  // logger.info('interceptors.response: ',config.url.indexOf("Authentication/Login"))
  // if (config.config.url.indexOf("Authentication/Login") !== -1) {
  //   logger.debug('respuesta del login:', config)

  // }

  return config;
});

// -------------------------------
// Response
// -------------------------------
apiClient.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      // NO logout si todavía hay refresh-token
      const hasRefreshToken = localStorage.getItem('refresh-token');

      if (!hasRefreshToken) {
        requestLogout()
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
